import React from 'react'

const DropdownIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8.707" height="5.061" viewBox="0 0 8.707 5.061" style={props.customStyle} className={props.customClass}>
    <path
      data-name="Path 10 Copy 5" d="M0,0,4,4,8,0" 
      transform="translate(0.354 0.354)" 
      fill={props.fill || "none"} 
      stroke={props.stroke || "#606060"} 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeMiterlimit="10" 
      strokeWidth="1"/>
  </svg>
  )
}

export default DropdownIcon

